import { create } from 'zustand';

export interface SelectionState {
  selectedItemIds: Set<string>;
  newlyCreatedItemId: string | null;

  // Drag state for toolbar drag-to-canvas
  isDraggingFromToolbar: boolean;
  draggedToolType: string | null;

  // Drag-to-board state
  dropTargetBoardId: string | null;

  // Actions
  selectItem: (itemId: string, additive?: boolean) => void;
  clearSelection: () => void;
  setSelectedItems: (itemIds: Set<string>) => void;
  setNewlyCreatedItemId: (id: string | null) => void;
  clearNewlyCreatedItem: () => void;
  setDraggingFromToolbar: (isDragging: boolean, toolType?: string | null) => void;
  setDropTargetBoardId: (boardId: string | null) => void;
}

export const useSelectionStore = create<SelectionState>((set, get) => ({
  selectedItemIds: new Set(),
  newlyCreatedItemId: null,
  isDraggingFromToolbar: false,
  draggedToolType: null,
  dropTargetBoardId: null,

  selectItem: (itemId, additive = false) => {
    const state = get();
    if (additive) {
      const newSelection = new Set(state.selectedItemIds);
      if (newSelection.has(itemId)) {
        newSelection.delete(itemId);
      } else {
        newSelection.add(itemId);
      }
      set({ selectedItemIds: newSelection });
    } else {
      set({ selectedItemIds: new Set([itemId]) });
    }
  },

  clearSelection: () => set({ selectedItemIds: new Set() }),

  setSelectedItems: (itemIds) => set({ selectedItemIds: itemIds }),

  setNewlyCreatedItemId: (id) => set({ newlyCreatedItemId: id }),

  clearNewlyCreatedItem: () => set({ newlyCreatedItemId: null }),

  setDraggingFromToolbar: (isDragging, toolType = null) => set({
    isDraggingFromToolbar: isDragging,
    draggedToolType: toolType,
  }),

  setDropTargetBoardId: (boardId) => set({ dropTargetBoardId: boardId }),
}));
